<template><section><h1>Pagination 分页</h1>
<h2>基本用法</h2>
<demo-block>
                    <div class="source" slot="source"><nt-pagination :total="199" :pageSize="24" @change="query"></nt-pagination>

</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-pagination</span> <span class="hljs-attr">:total</span>=<span class="hljs-string">"199"</span> <span class="hljs-attr">:pageSize</span>=<span class="hljs-string">"24"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"query"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-pagination</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-attr">methods</span>: {
        query(num){
            <span class="hljs-built_in">console</span>.log(<span class="hljs-string">`页码改变了,是<span class="hljs-subst">${num}</span>`</span>);
        }
    }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">curPage</td>
<td style="text-align:left">当前页码</td>
<td style="text-align:left">Number</td>
<td style="text-align:left">-</td>
<td style="text-align:left">1</td>
</tr>
<tr>
<td style="text-align:left">total</td>
<td style="text-align:left">总条数</td>
<td style="text-align:left">Number</td>
<td style="text-align:left">-</td>
<td style="text-align:left">-</td>
</tr>
<tr>
<td style="text-align:left">pageSize</td>
<td style="text-align:left">每页显示条数</td>
<td style="text-align:left">Number</td>
<td style="text-align:left">-</td>
<td style="text-align:left">-</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th style="text-align:left">事件名称</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">change</td>
<td style="text-align:left">页码改变就触发该事件</td>
<td style="text-align:left">当前要显示的页码</td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default {
    methods: {
        query(num){
            console.log(`页码改变了,是${num}`);
        }
    }
};
</script>